import {Icon, IconColors, TableIconText} from '../../global';

export const ocrIcons = (status: number): TableIconText => {
  let label;
  let color;
  let icon = Icon.DOCUMENT_SEARCH;
  let loading = false;
  switch (+status) {
    case 0:
      label = 'LBL_UPLOAD_FILL.OCR.NOT';
      color = IconColors.RED;
      break;
    case 1:
      label = 'LBL_UPLOAD_FILL.OCR.NOT_FOUND';
      color = IconColors.ORANGE;
      break;
    case 4:
      label = 'LBL_UPLOAD_FILL.OCR.FOUND_FILED';
      color = IconColors.RED;
      icon = Icon.INFO;
      break;
    case 5:
      label = 'LBL_UPLOAD_FILL.OCR.DETAILED_DATA';
      color = IconColors.ORANGE;
      icon = Icon.INFO;
      break;
    case -1:
      label = 'LBL_UPLOAD_FILL.DOCUMENT_OCR';
      loading = true;
      break;
    default:
      label = 'LBL_UPLOAD_FILL.OCR.FOUND';
      color = IconColors.GREEN;
      break;
  }
  return {
    icon,
    label,
    color,
    loading
  };
}
